module.exports = __webpack_public_path__ + "static/media/mcv__brand.a245c902.png";